export default __webpack_public_path__ + "static/media/HABSM.aafa43eb.png";